import { render, staticRenderFns } from "./SendMessageMenu.vue?vue&type=template&id=50ae807a"
import script from "./SendMessageMenu.vue?vue&type=script&lang=js"
export * from "./SendMessageMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports